import axios from 'axios';
import {
  getShopifyAxiosConfig,
  getShopifyGqlEndpoint,
  getShopifyUrlAndToken,
} from 'gatsby-theme-hem-store/src/shopify';
import { StoreApi } from 'zustand';

import { CustomerStore } from './useCustomer';

const query = `
mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
  customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
    customerAccessToken {
      accessToken
      expiresAt
    }
    customerUserErrors {
      code
      field
      message
    }
  }
}
`;

export function loginMultipass(
  set: StoreApi<CustomerStore>['setState'],
  get: StoreApi<CustomerStore>['getState'],
): (input: { email: string }) => Promise<void> {
  return async (input: { email: string }) => {
    try {
      const multipassTokenReq = await fetch(`/api/dev-multipass`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ customerData: { email: input.email } }),
      });

      if (!multipassTokenReq.ok) {
        throw new Error(
          `${multipassTokenReq.status} ${multipassTokenReq.statusText}`,
        );
      }

      const multipassTokenReqJson = await multipassTokenReq.json();

      const { token } = getShopifyUrlAndToken();
      const shopifyGqlEndpoint = getShopifyGqlEndpoint();
      const shopifyAxiosConfig = getShopifyAxiosConfig(token);

      const tokenRequest = await axios.post(
        shopifyGqlEndpoint,
        {
          query,
          variables: { multipassToken: multipassTokenReqJson.token },
        },
        shopifyAxiosConfig,
      );

      const accessToken =
        tokenRequest?.data?.data?.customerAccessTokenCreateWithMultipass
          ?.customerAccessToken?.accessToken;
      const expiresAt =
        tokenRequest?.data?.data?.customerAccessTokenCreateWithMultipass
          ?.customerAccessToken?.expiresAt;

      if (accessToken && expiresAt) {
        set({
          customerAccessToken: {
            accessToken,
            expiresAt,
          },
          customerLoginError: undefined,
        });
        get().___fetchCustomer();
      } else {
        console.error('No accessToken or expiresAt');
      }
    } catch (err) {
      // ignore
      console.error(err);
    }
  };
}
